module.exports = __webpack_public_path__ + "media/images/portugal_center/Castelo_almourol-22c5c9416b02ee9e0e6f401c00410208.jpg";